import { NumberInput } from '@mantine/core';

import { ProphetRuleForm } from '../../../hooks/useProphetRuleForm';

import config from '@/config';

type Props = {
  form: ProphetRuleForm;
};

const isProd = config.isProd;

export const Intervals = ({ form }: Props) => {
  return (
    <div>
      <NumberInput
        label="Сколько ожидать требования"
        {...form.getInputProps('intervals.requirements')}
        withAsterisk
        min={isProd ? 0.1 : 0.001}
        max={23}
        decimalScale={isProd ? 2 : 4}
        step={isProd ? 0.1 : 0.001}
        suffix=" ч."
      />
    </div>
  );
};
